/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Err_Source_QtyInputs */

const vi_scl_new_err_source_qty = /** @type {(inputs: Scl_New_Err_Source_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập KL xuất từ lô nguồn (>= 0)`)
};

/**

* @param {Scl_New_Err_Source_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_err_source_qty = /** @type {((inputs?: Scl_New_Err_Source_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Err_Source_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_err_source_qty(inputs)
});